import React from 'react'
import styled from 'styled-components'
import styles from '../../constants/styles'

// TODO fix
// eslint-disable-next-line react/prop-types
const localNotification = ({ localNotification: notif }) => (
  <Container>{notif}</Container>
)

export default localNotification

const Container = styled.div`
  width: 100%;
  height: ${styles.height.small};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: ${styles.colors.gold};
  color: ${styles.colors.black};
  position: fixed;
  top: 64px;
  z-index: 30;

  @media (min-width: 601px) {
    top: 96px;
  }
`
